import { Directive, Input, ViewContainerRef, Compiler, ModuleWithComponentFactories, Type, NgModule, Component, OnChanges, ComponentRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import * as $ from 'jquery';
import { QRCodeModule } from 'angularx-qrcode';

@Directive({
    selector: '[compile]'
  })
  export class CompileDirective implements OnChanges {
    @Input() compile: string;
    @Input() compileContext: any;
  
    compRef: ComponentRef<any>;
  
    constructor(private vcRef: ViewContainerRef, private compiler: Compiler) {}
  
    ngOnChanges() {
      if(!this.compile) {
        if(this.compRef) {
          this.updateProperties();
          return;
        }
        throw Error('You forgot to provide template');
      }
  
      this.vcRef.clear();
      this.compRef = null;
  
      const component = this.createDynamicComponent(this.compile);
      const module = this.createDynamicModule(component);
      this.compiler.compileModuleAndAllComponentsAsync(module)
        .then((moduleWithFactories: ModuleWithComponentFactories<any>) => {
          let compFactory = moduleWithFactories.componentFactories.find(x => x.componentType === component);
  
          this.compRef = this.vcRef.createComponent(compFactory);
          this.updateProperties();
        })
        .catch(error => {
          console.log(error);
        });
    }
  
    updateProperties() {
      for (var prop in this.compileContext) {
        console.log(prop)
        console.log(this.compileContext[prop])
        this.compRef.instance[prop] = this.compileContext[prop];
      }

      
     
      setTimeout(() => {
        this.SetUpInvoiceDesign()
        window.print()
      }, 1000)
    }
  
  
  

    SetUpInvoiceDesign() {


      $(".page-copy-container-wrapper").each(function () {
        //var totalpage = 1180;
        var totalpage = 1190;
        var header = $(this).find(".page-wrapper .page-header").height();
        var footer = $(this).find(".page-wrapper .page-footer").height();
        var contentheight = totalpage - (Number(header) + Number(footer));
        console.log('headerheight:' + header);
        console.log('footerheight:' + footer);
        console.log('contentheight:' + contentheight);

        $(this).find(".page-wrapper .page-content").height(contentheight);
        $(this).find(".tableboxLine").height(contentheight);
        var countPages = 1;
        var countHeight = 0;
        $(this).find("#billdetailstbody tr").each(function () {
          countHeight += Number($(this).height())-6;
          // console.log(contentheight)
          // console.log(countHeight)
          // console.log(countPages)
          if (countHeight > contentheight) {
            countPages++;
            countHeight = Number($(this).height());
          }
          $(this).addClass("pageRow" + countPages);
        });
  
        var page_wrapper = $(this).find(".page-wrapper-tr");
        for (var i = 1; i < countPages; i++) {
          page_wrapper.clone().appendTo($(this).find(".page-wrapper-table"));
        }
  
  
        var counter = 1;
        $(this).find(".page-wrapper").each(function () {
          $(this).find(".billdetailstbody tbody tr:not(.pageRow" + counter + ")").remove();
          counter++;
        });
  
  
      });
       
      var wrapper = $(".page-copy-container-wrapper");
      var count = wrapper.length;
      if (count > 1) {
        var htmlToMove = "";
        for (var i = 0; i < count; i++) {
          htmlToMove += wrapper.eq(i).html();
        }
        wrapper.first().html(htmlToMove);
        wrapper.not(":first").remove();
      }
  
            
    
                                            
    

      
    
    var wrapper = $(".page-wrapper-tr");
    var scount = wrapper.length;
   
    if (scount > 1) {
    
      $(".page-wrapper-tr").each(function (this,index) {
       
        var wrapper = $(".page-wrapper-tr");
        var scount = wrapper.length;
   
        if (index!=(scount-1)) {
          // $(this).find(".page-wrapper .page-footer").css('display','none');
          // $(this).find(".page-wrapper .page-footerfirst").css('display','block');
          // footer.addClass("")

           $(this).find(".page-footer").find("table").each(function (index, tr) {
             $(tr).css('color', 'white');
          

             $(tr).each(function (sindex, td) {
                $(td).find(".summaryheader").css('color', '#495057');
              
              });
             
            
              console.log(index);
            });;
          
          // $('table').each(function (index, tr) {
          //   $(tr).css('color', 'white');
          //   console.log(index);
          // });
          
        }
        else{
         // $(this).find(".page-wrapper .page-footerfirst").css('display','none');
        }
    
       
      })
    }

      
  
    }
  
  
    private createDynamicComponent (template:string) {
      @Component({
        selector: 'custom-dynamic-component',
        template: template,
     
      })
      class CustomDynamicComponent {



        
      }
      return CustomDynamicComponent;
    }
  
    private createDynamicModule (component: Type<any>) {
      @NgModule({
        // You might need other modules, providers, etc...
        // Note that whatever components you want to be able
        // to render dynamically must be known to this module
        imports: [CommonModule,QRCodeModule],
        declarations: [component]
      })
      class DynamicModule {}
      return DynamicModule;
    }
  }